import { DesignSystemModule } from './../../../../theme/design-system/design-system.module';
import { ComponentsModule } from './../../../components/components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PayPublicServicesAutomaticPageRoutingModule } from './pay-public-services-automatic-routing.module';

import { PayPublicServicesAutomaticPage } from './pay-public-services-automatic.page';
import { CardCategoryComponent } from './card-category/card-category.component';
import { FormPayPublicServicesAutomaticComponent } from './form-pay-public-services-automatic/form-pay-public-services-automatic.component';
import { BrMaskerModule } from 'br-mask';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    DesignSystemModule,
    PayPublicServicesAutomaticPageRoutingModule,
    ReactiveFormsModule,
    BrMaskerModule,
  ],
  declarations: [PayPublicServicesAutomaticPage,CardCategoryComponent, FormPayPublicServicesAutomaticComponent]
})
export class PayPublicServicesAutomaticPageModule {}
